'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'bolt';
var width = 512;
var height = 512;
var aliases = [9889,"zap"];
var unicode = 'f0e7';
var svgPathData = ['M88.4 256l152 0c-2.1 7.5-20.2 73.5-54.5 198.1l237.7-198.1-152 0c2.1-7.5 20.2-73.5 54.5-198.1L88.4 256z', 'M322.4 192C358.9 59.4 379.4-15.3 384-32L340.9 3.9 38.4 256 0 288 198.4 288 189.6 320c-36.5 132.6-57 207.3-61.6 224l43.1-35.9 302.5-252.1 38.4-32-198.4 0 8.8-32zm101.2 64L185.9 454.1c34.3-124.6 52.4-190.6 54.5-198.1l-152 0 237.7-198.1C291.8 182.5 273.7 248.5 271.6 256l152 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBolt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;